import React,{Component} from "react";
import {
  Card,
  CardHeader,
  CardBody,
  
  Row,
  Col,
 
 
  Button,

  DatePicker
} from "shards-react";


import firebase from '../firebase';
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import ConfirmModal from '../ConfirmModal';

export default class DisplayAttendance extends Component{

  constructor(props) {
    super(props);
  
    this.state = { 
                   date:null,
                   dateobject:null,
                   attendance_list:[],
                   loading:false,
                   no_attendance:true,
                   total_students:undefined,
                   total_present:undefined,
                   showConfirmModal:false,
                  };

    this.setDate = this.setDate.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.get_attendance_data = this.get_attendance_data.bind(this);
    this.get_merged_data = this.get_merged_data.bind(this);
    this.log_sample = this.log_sample.bind(this);
    this.setConfirmModalVisibility = this.setConfirmModalVisibility.bind(this);
    this.deletedata  = this.deletedata.bind(this);
  }



  setConfirmModalVisibility =(data)=>{
      if(data==="close"){
        this.setState({showConfirmModal:false});
      }
      else{
          this.setState({showConfirmModal:true});
      }
  }

  setDate=(date)=>{
        var dd = (date.getDate()).toString();
        var mm = (date.getMonth()+1).toString();
        var yyyy = (date.getFullYear()).toString();
        
        if(dd.length===1){
            dd = '0' + dd;
        }
        if(mm.length===1){
          mm = '0' + mm;
        }
        if(yyyy.length===1){
           yyyy = '0' + yyyy;
        }
        var format  = dd+"-"+mm+"-"+yyyy;
        this.setState({date:format},this.get_attendance_data);
        this.props.set_selected_date(format);
        
  }

   handleDateChange(value) {
        this.setState({dateobject:new Date(value)})
        this.setDate(new Date(value));
    }

  componentDidMount(){
    this.handleDateChange(new Date());
    this.setDate(new Date());
  }

  get_merged_data = (ab_list,pres_list)=>{

      var attendance_list = [];
      var data = {};
      ab_list.forEach(function(doc){
            data = {
                name: doc.split(":")[1],
                wasPresent:false,
            }
            attendance_list.push(data);
      })

      pres_list.forEach(function(doc){
            data = {
                name: doc.split(":")[1],
                wasPresent:true,
            }
            attendance_list.push(data);
      })

      return attendance_list;



  }


  log_sample(){
    console.log(this.state);
    console.log("Class "+this.props.selected_class);
  }

  get_attendance_data = () =>{

      var class_name = this.props.selected_class;
      var date = this.state.date;
      var code = class_name+":"+date;

      
      var that = this;
      if(class_name===undefined){
        console.log("class undefined");
        return;
      }

      this.setState({loading:true,total_students:undefined,total_present:undefined,attendance_list:[],no_attendance:true});
      firebase.firestore().collection('Attendance').doc(code).get().then(function(doc){
            if(!doc.exists){
                that.setState({loading:false,no_attendance:true},that.log_sample);
                console.log("Doc doesnt exists");
                return;
            }
            console.log("Continued");
            var  data = doc.data();
            var absent_list = data.absent_list;
            var present_list = data.present_list;

            var total_students = absent_list.length+present_list.length;  
            var total_present = present_list.length;

            var merged_data = that.get_merged_data(absent_list,present_list);
            
            console.log(merged_data);
            
            that.setState({
                            loading:false,
                            total_students:total_students,
                            total_present:total_present,
                            attendance_list:merged_data,
                            no_attendance:false
                          },that.log_sample);

      }).catch(function(err){
          console.log(err);
          that.setState({loading:false});
      })

  }



  componentDidUpdate(prevProps) {
       
        if (this.props.selected_class !== prevProps.selected_class) {
           console.log("Class Changed");  
           this.get_attendance_data();
        }

        if(this.props.trigger_get){
            this.get_attendance_data();
            this.props.stop_trigger_get_attendance();
        }
  }


  deletedata=()=>{

      var class_name = this.props.selected_class;
      var date = this.state.date;
      var code = class_name+":"+date;
      var that = this;


      this.setState({loading:true});
      firebase.firestore().collection('Attendance').doc(code).delete().then(function(){
              toast('Attendance Deleted Succesfully !', {containerId: 'A'});
              that.setState({loading:true});
              that.get_attendance_data();
      }).catch(function(err){
              console.log(err);
             toast('Error Deleting Attendance !', {containerId: 'A'});
      })  


  }


  render(){
    
    var dateobj="";
    if(this.state.dateobject){
          dateobj = (this.state.dateobject).toString();
          dateobj = dateobj.slice(0,15);  
    }
    

    return(
      <Card small className="mb-4">
    <CardHeader className="border-bottom">
      <h6 className="m-0">Attendance</h6>
    </CardHeader>
    <CardBody className="pt-0"> 

      <Row className="border-bottom py-2 bg-light">
            <Col sm="12" className="d-flex mb-2 mb-sm-0">
              

              <Col md="4">

                <DatePicker 
                    placeholderText={this.state.date}
                    onChange={this.handleDateChange}
                />
              
              </Col>
                {
                  (this.props.selected_class!==undefined && this.state.attendance_list.length>0) &&
                <Row>

                 <Col md="10" style={{marginTop: '1%'}}>
                      {this.state.total_present+" of "+this.state.total_students+" students are present"}
                  </Col>
                

              <Col md="2">

                  <Button theme="danger" size="md" style={{marginLeft: '5%'}} onClick={()=>{this.setConfirmModalVisibility('open')}}>Delete</Button>
              
              </Col>
              </Row>

            }


            </Col>
            
          </Row>

         

            <Col className="mb-0 scroll_list-group" lg="12" style={{marginTop: '2%'}}>
             
            <Row> 
                  
                 {
                    this.state.attendance_list.map((item,i)=>{
                      return <StudentItem  data={item} 
                                    key={i} 
                                    index={i+1} 
                                  />
                    })
              }


            </Row>
          


                    {//No attendance info ui below
                    }

                  { (this.state.no_attendance && !this.state.loading && !(this.props.selected_class===undefined) ) &&
                   <div style={{margin: '15%'}} className="text-muted">
                        <div  style={{fontSize:20}}>
                          {"No Attendance Added on "+dateobj}
                        </div>
                        <div style={{margin: '5%',marginLeft: "30%"}}>
                            <Button theme="info" size="md" onClick={this.props.add_attendance}>Add Attendance</Button>
                        </div>
                  
                  </div>
                  }

                  { (!this.state.no_attendance && !this.state.loading && (this.state.attendance_list.length===0) ) &&
                   <div style={{margin: '15%'}} className="text-muted">
                        <div  style={{fontSize:20,textAlign: 'center'}}>
                          {"No Students Avialable"}
                        </div>
                        <div style={{margin: '5%',marginLeft: "30%",fontSize:50}}>
                              <i class="material-icons">airline_seat_individual_suite</i>
                        </div>
                  
                  </div>
                  }

                  {
                   (this.props.selected_class===undefined) &&
                   <div style={{margin: '10%'}} className="text-muted">
                    <Row>
                        <div style={{fontSize:40,textAlign: 'center'}}>
                              <i class="material-icons">arrow_back</i>
                        </div>
                        <div  style={{marginLeft: "10%",fontSize:30,textAlign: 'center',color:'blue'}}>
                          {"Kindly Select Class"}
                        </div>
                        
                    </Row>
                  </div>
                  }

                  {
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
                  }
            </Col> 


             <ConfirmModal
                     show={this.state.showConfirmModal}
                     onHide={() =>this.setConfirmModalVisibility('close')}
                     handleClose={() =>this.setConfirmModalVisibility('close')}
                     onAccept={()=>this.deletedata()}
                      message={"Are you Sure?\nThe data will be deleted permanently!"}
              />

       

    </CardBody>
  </Card>
)
  }
}

class StudentItem extends Component{

  render(){

      var icon_name = (this.props.data.wasPresent)?"done":"cancel";
      var color_name = (this.props.data.wasPresent)?"blue":"red";

      return(

        <Col lg="4">
                        <div style={{margin:'3%'}}>
                          <Row>
                            <div>
                                {this.props.data.name}
                            </div>
                                
                                <div style={{color:color_name,fontSize: 20,marginLeft: '10%'}}>
                                    <i class="material-icons">{icon_name}</i>
                                </div>
                            
                          </Row>
                        </div>
          </Col>

      )

  }
}